<!-- 控销商品列表 -->
<template>
   <div class='page_content'>
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
        <limitCustomersAction v-if="showStatus" ref="limitCustomersAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></limitCustomersAction>
    </el-drawer>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <div class="page_content_top_line">
            <el-button type="primary" size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
               {{buttonValue.jurName}}
            </el-button>
            <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getPageInfo()">
               刷新
            </el-button>
         </div>
         <div class="page_content_top_line">
            <el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData.jurHead" size="mini">
               <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in pageShowData.jurHead.jurconfigform" :key="formOneKey">
                  <el-input v-if="formOneValue.fieldType == 'search'" clearable v-model="getRequestData[formOneValue.entityField]"
                     @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)">
                     <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                  </el-input>
                  <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                            :key="item.key" :label="item.value" :value="item.key">
                        </el-option>
                    </el-select>
                  <el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" clearable size="mini" :maxlength="$store.state.inputLength"></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="searchData">查询</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>

      <div class="page_content_center">
         <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" height="100%" border style="width: 100%" highlight-current-row size="mini">
            <el-table-column label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <!-- 控销商品列表主表格 -->
            <el-table-column v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField"
               :min-width="tableValye.fieldWeight" :label="tableValye.showField">
               <template slot-scope="scope">
                  <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                     {{scope.row.isWms == 0 ? '否' : '是'}}
                  </el-tag>
                  <el-tag size="mini" v-if="tableValye.entityField == 'controlType'">
                     {{scope.row.controlType == 0 ? '单位名称' : scope.row.controlType == 1 ?'单位类型' : "地区" }}
                  </el-tag>
                  <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                     {{$common.getIsGsp(tableValye.formatterContent,scope.row.psomState)}}</el-tag>
                  <span v-else-if="tableValye.fieldType == 'date'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                     </span>
                  </span>
                  <span v-else-if="tableValye.fieldType == 'formatter'">{{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</span>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                  </span>
                  <span v-else>
                     {{scope.row[tableValye.entityField]}}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="getRequestData.page" :page-sizes="[30,50,100,500]" :page-size="30"
            layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
         </el-pagination>
      </div>

      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Vue from "vue";
import SearchScheme from "../../byComponents/SearchScheme.vue";
import limitCustomersAction from "@/components/limitCustomersAction.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      limitCustomersAction
   },
   data() {
      //这里存放数据
      return {
         getRequestData: {
            batchno: "",
            bgmName: "",
            businessId: "",
            page: 1,
            rows: 30,
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
            pisOrderDetail: [],
         },
         buttonList: [],
         pageShowData: [],
         formDataList: [],
         selectedDataIndex: 0,
         exId: "",
         seId: "",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogExtract: false,
         seType: "",
         smId: "",
         isShowTooltip: false,
         showStatus: false,
         actionData: {},
         parentSearchData: {},
         sField: "",
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.bgmName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.bmId = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      //获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key === val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            return newStr;
         } catch (ex) {
            return str;
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 0:
               this.showStatus = true;
               this.actionData = {
                  cate: 0,
                  formData: this.formDataList,
                  oldData: "",
                  orderId: "",
                  printSouce: "",
                  printJurId: "",
               };
               break;
            case 1:
               var dataInfo = this.returnData.list[this.selectedDataIndex];
               if (!dataInfo) {
                  this.$message({
                     message: "请先选中要操作的数据",
                     type: "error",
                  });
                  return false;
               }
               this.showStatus = true;
               this.actionData = {
                  cate: 1,
                  formData: this.formDataList,
                  oldData: dataInfo,
                  orderId: dataInfo.psomId,
                  printSouce: "",
                  printJurId: "",
               };
               break;
            case 2:
               this.delDataAction(); 
               break;
            case 3:
               // this.submitDataAction();
               break;
            case 8:
               // this.showPrintPlan();
               break;
            case 15:
               this.openFormDesign();
               break;
         }
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path);
         this.$refs["customDesign"].openBox(
            pathInfo.jurId,
            this.pageShowData,
            pathInfo.jurName
         );
      },
       // 删除数据
       delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.cpmId],
                    };
                    let responseData = await this.$http.deletepscontrol(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {});
        },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
      // 子组件触发
      drawerCancel(e) {
         this.showStatus = false;
         if (e == 1) this.getDataList();
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: {
                     isPenetrate,
                  }, //参数
               },
               "*"
            );
         }
      },
      //检索带回数据
      changeInputModel(val) {
         console.log(val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
         if (this.seType == "bgmName") {
            this.getRequestData.bgmId = val.bgmId;
            this.getRequestData.bgmName = val.bgmName;
            // this.getRequestData.splice(1, 0);
         } else if (this.seType == "batchno") {
            // this.getRequestData[this.seIndex].bgmId = val.bgmId;
            // this.getRequestData[this.seIndex].bgmName = val.bgmName;
            // this.getRequestData.splice(1, 0);
         } else {
            this.paramValue(val);
         }
         } 
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.getRequestData[item] = val[item];
         });
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getExtractName(e) {
         console.log(e);
         this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true;
         this.seId = sId;
         this.sField = sField;
         this.seType = type;
         this.parentSearchData[type] = this.getRequestData[type];
         console.log(this.seType);
      },
      //   isShowData(name, value) {
      //      switch (name) {
      //         case "supplier":
      //            var dataInfo = sessionStorage.getItem("selectSupplierData");
      //            if (dataInfo) {
      //               dataInfo = JSON.parse(dataInfo);
      //               this.getRequestData.bgmId = dataInfo.bgmId;
      //               this.getRequestData.bgmName = dataInfo.bgmName;
      //            }
      //            break;
      //      }
      //   },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton();
         
      },
// 获取数据列表
      async getDataList() {
         let responseData = await this.$http.querypscontrol(
            this.getRequestData
         );
         if (responseData && responseData.status == 200) {
            let resData = JSON.parse(JSON.stringify(responseData));
            this.returnData.list = resData.result.list;
            this.returnData.pages = resData.result.pages;
            this.returnData.total = resData.result.total;
            this.returnData.pageNum = resData.result.pageNum;
            this.selectedDataIndex = 0;
           
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId],
         });
         if (responseData.status == 200) {
            console.log(responseData);
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList;
            this.getDataList();
            this.getButtonList();
            // this.formDataList = [];
            // this.pageShowData.forEach((item, i) => {
            //   if (i > 3) this.formDataList.push(this.pageShowData[i]);
            // });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {},
   beforeCreate() {}, //生命周期 - 创建之前
   beforeMount() {}, //生命周期 - 挂载之前
   beforeUpdate() {}, //生命周期 - 更新之前
   updated() {}, //生命周期 - 更新之后
   beforeDestroy() {}, //生命周期 - 销毁之前
   destroyed() {}, //生命周期 - 销毁完成
   activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.el-drawer {
   outline: none;
}
</style>